// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { useMemo } from 'react';
import { type TradesProps } from '../components/trades';
import { useConst } from '@shared/ui-kit/hooks';

export const useTrades = ({ tableData }: TradesProps) => {
  const traderExcelData = useMemo(
    () =>
      tableData.map(
        ({
          ticker,
          columnName,
          contracts_number,
          delta_volume,
          expected_volume: expected_outstanding_balance,
          operation,
          realized_capital_gains,
          unrealized_capital_gains,
          volume: outstanding_balance,
          gain_loss,
          price,
        }) => ({
          ticker,
          name: columnName?.name,
          date: new Date().toISOString().split('T')[0],
          contracts_number,
          expected_outstanding_balance,
          realized_capital_gains,
          unrealized_capital_gains,
          outstanding_balance,
          delta_volume,
          price,
          gain_loss,
          operation,
        }),
      ),
    [tableData],
  );

  const traderHeaderOrder = useConst([
    'ticker',
    'name',
    'date',
    'contracts_number',
    'expected_outstanding_balance',
    'realized_capital_gains',
    'unrealized_capital_gains',
    'outstanding_balance',
    'delta_volume',
    'price',
    'gain_loss',
    'operation',
  ]);

  return {
    traderExcelData,
    traderHeaderOrder,
  };
};
